import React, {useEffect, useMemo, useState} from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {useIsDrawerMode} from '../../util/Ares/customHooks';
import TimeTrackerContainer from '../Common/TimeTracker/TimeTrackerContainer';
import {useUserPreferences} from '../../util/customHooks';
import './index.scss';
import '@ey/motif-react-wrapper/ey-asu-motif.css';
import '@ey/styled-theme/styles.css';
import './main.less';
import classnames from 'classnames';

export default function Main({isMFE, children}) {
	const features = useSelector((store) => store.configurations?.features);

	const appVersionState = useSelector((store) => store.appVersion);

	const userPreferences = useUserPreferences();

	const isStandaloneView = useSelector((store) => store.isStandaloneView);

	const isDrawerMode = useIsDrawerMode();

	const location = useLocation();

	const isMinimalView = useMemo(() => {
		return location.pathname.toLowerCase().includes('/guidedworkflowv2/minimal');
	}, [location.pathname]);

	const showTimeTracker = useMemo(() => {
		if (!isMFE && !isDrawerMode && features?.enableTimeTracker && !userPreferences.isGuestUser && !isMinimalView) {
			return true;
		}

		return false;
	}, [isMinimalView, isMFE, isDrawerMode, features?.enableTimeTracker, userPreferences.isGuestUser]);

	const matchesPath = useMemo(() => {
		const paths = ['/guidedworkflow', '/guidedworkflowv2', '/fit', '/standalone', '/drydock'];

		const currentPath = window.location.pathname.toLowerCase();

		const matchesPath = paths.some((path) => currentPath.startsWith(path));
	}, []);

	useEffect(() => {
		if (appVersionState.upgrade) {
			localStorage.setItem('app.version', appVersionState.version);
			window.location.reload();
		}
	}, [appVersionState]);

	const [hasLeftSection, setHasLeftSection] = useState(false);

	useEffect(() => {
		setHasLeftSection(document.documentElement.classList.contains('leftSideSection'));
	}, []);

	const mainClasses = classnames('main', 'key', {
		training: features?.isTrainingEnvironment
	});

	const containerClasses = classnames('MainContainerWrapper', {
		'left-margin': !matchesPath && !hasLeftSection
	});

	return (
		<section className={mainClasses}>
			<MainContainerWrapper className={containerClasses}>
				{children}
				{showTimeTracker && <TimeTrackerContainer />}
			</MainContainerWrapper>
		</section>
	);
}

const MainContainerWrapper = styled.section`
	display: flex;
	flex-direction: column;
	flex: 1 1 0;
	overflow-x: hidden;
	max-width: 2048px;
	&.left-margin {
		margin-left: var(--px-390);
	}
	&:has(.cookie-settings) {
		margin-left: 0;
	}
`;
